/**
 * Hides/shows accordion content after click
 */
class Accordion extends HTMLElement {
  /**
   * connectedCallback
   */
  connectedCallback() {
    this.addEventListener('click', (e) => {
      e.stopPropagation();
      this.classList.toggle('active');
    });
  }
}
customElements.define('accordion-item', Accordion);
